import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';

const $=window.$;

//const $=window.$;
// const win=window;

class AssessementMail extends Component {
	constructor(props) {
		super(props);

        this.state={
				mails : props.mail,
				evals : props.evals,
				comp : props.comp
				};

		this.sentMail = this.sentMail.bind(this);

	}

	sentMail(){
		let mail 	= this.state.mails;
		let name = this.state.evals;
		let comp = this.state.comp;
		let sub = this.refs.subject.value;
		let message = this.refs.message.value;
		let lr_mail = Common.getUserData('primaryEmail',true);
		Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'learning/performance-mail', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    mail:mail,
					name:name,
					comp:comp,
					sub : sub,
					msg : message,
					lr_mail : lr_mail
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
					Common.reactLoader("hide");
               		if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      	} else {
			        Common.message("", 'Your mail to '+name+' has been sent successfully', "success");
					$('form#asssendmail')[0].reset();

					}
   				});
	}

	componentWillReceiveProps(nextProps) {
	
    }

    


	componentDidMount() {

	}

	render() {

		return (
			 <div>
			 	<p>Send a message to <strong>{this.state.evals}</strong> regarding assessment of <strong>{this.state.comp}</strong>.</p>
			    <div className="table-cont5 tabgrey" >
			        <form name="asssendmail" id="asssendmail">
			        	<div className="mentermailrow">
				               <div className="mentermaillft">To</div>
			                <div className="mentermailrgt">{this.state.mails}</div>
			            </div>
			            <div className="mentermailrow">
			               <div className="mentermaillft">Subject <span className="redtext">*</span></div>
			               <div className="mentermailrgt"><input type="text" ref='subject' className="txtbox"/></div>
			            </div>
			            <div className="mentermailrow">
			                <div className="mentermaillft">Message <span className="redtext">*</span></div>
			                <div className="mentermailrgt"><textarea  cols="20" rows="15" ref='message'/></div>
			          	</div>
			          	<div className="mentermailrow">
			            	<div className="mentermaillft">&nbsp;</div>
			            	<div className="mentermailrgt"><div className="button"><span><input className="mail-icon" type="button" name="submit" value="Send Mail" alt="Send Mail" title="Send Mail" onClick={()=>this.sentMail()}/></span></div></div>
			          	</div>
			        </form>
			    </div>
			 </div>
			);

	}
}

export default AssessementMail;



// WEBPACK FOOTER //
// ./src/learning_records/my_performance/AssessementMail.js